module.exports = __webpack_public_path__ + "static/media/me-10.0219a1e0.svg";